export const ASSIGN_ALERTS_TO_USER = 'ASSIGN_ALERTS_TO_USER';
export const ASSIGN_ALERTS_TO_USER_SUCCESS = 'ASSIGN_ALERTS_TO_USER_SUCCESS';
export const ASSIGN_ALERTS_TO_USER_FAIL = 'ASSIGN_ALERTS_TO_USER_FAIL';
export const ALERT_ACTION_INFO_MODAL_CLOSE = 'ALERT_ACTION_INFO_MODAL_CLOSE';
export const ASSIGN_ALERTS_TO_USER_RESET = 'ASSIGN_ALERTS_TO_USER_RESET';

export const assignAlertsToUser = ({ alertIds, user }) => ({
  type: ASSIGN_ALERTS_TO_USER,
  payload: { alertIds, user }
});

// FIN-12893 — Bulk Assign is partial on the BE ({ success, assigned: [...], notFound: [...] });
// carry the response so the info modal can say what was NOT assigned instead of a plain success.
export const assignAlertsToUserSuccess = (result = null) => ({
  type: ASSIGN_ALERTS_TO_USER_SUCCESS,
  payload: { result }
});

export const assignAlertsToUserFail = (message) => ({
  type: ASSIGN_ALERTS_TO_USER_FAIL,
  payload: { message }
});

export const alertActionInfoModalClose = () => ({
  type: ALERT_ACTION_INFO_MODAL_CLOSE
});

export const assignAlertsToUserRest = () => ({
  type: ASSIGN_ALERTS_TO_USER_RESET
});

export const BULK_UPDATE_ALERT_STATUS =
  'cm/alertAction/BULK_UPDATE_ALERT_STATUS';
export const BULK_UPDATE_ALERT_STATUS_SUCCESS =
  'BULK_UPDATE_ALERT_STATUS_SUCCESS';
export const BULK_UPDATE_ALERT_STATUS_FAIL = 'BULK_UPDATE_ALERT_STATUS_FAIL';
export const BULK_UPDATE_ALERT_STATUS_RESET = 'BULK_UPDATE_ALERT_STATUS_RESET';

export const bulkUpdateAlertStatus = ({ alertIds, status, reason }) => ({
  type: BULK_UPDATE_ALERT_STATUS,
  payload: { alertIds, status, reason }
});

export const bulkUpdateAlertStatusSuccess = (data) => ({
  type: BULK_UPDATE_ALERT_STATUS_SUCCESS,
  payload: data
});

export const bulkUpdateAlertStatusFail = (message) => ({
  type: BULK_UPDATE_ALERT_STATUS_FAIL,
  payload: { message }
});

export const bulkUpdateAlertStatusReset = () => ({
  type: BULK_UPDATE_ALERT_STATUS_RESET
});

export const BULK_UPDATE_CASE_STATUS = 'BULK_UPDATE_CASE_STATUS';
export const BULK_UPDATE_CASE_STATUS_SUCCESS =
  'BULK_UPDATE_CASE_STATUS_SUCCESS';
export const BULK_UPDATE_CASE_STATUS_FAIL = 'BULK_UPDATE_CASE_STATUS_FAIL';
export const BULK_UPDATE_CASE_STATUS_RESET = 'BULK_UPDATE_CASE_STATUS_RESET';

// FIN-10515 (re-open 2026-04-16): Include doChecker so the "Send cases for
// review" flow actually flags the bulk update as checker-bound. The BE code
// path (CasesService.bulkUpdateCaseStatus → updateCaseResolvedStatuses) is
// already gated on this flag — it was never reaching BE because the action
// creator dropped it from the payload.
export const bulkUpdateCaseStatus = ({
  caseIds,
  status,
  reason,
  doChecker
}) => ({
  type: BULK_UPDATE_CASE_STATUS,
  payload: { caseIds, status, reason, doChecker }
});

export const bulkUpdateCaseStatusSuccess = (data) => ({
  type: BULK_UPDATE_CASE_STATUS_SUCCESS,
  payload: data
});

export const bulkUpdateCaseStatusFail = (message) => ({
  type: BULK_UPDATE_CASE_STATUS_FAIL,
  payload: { message }
});

export const bulkUpdateCaseStatusReset = () => ({
  type: BULK_UPDATE_CASE_STATUS_RESET
});

// FIN-10098: Apply alert status to other alerts in case
export const APPLY_ALERT_STATUS_BULK_IN_CASE =
  'APPLY_ALERT_STATUS_BULK_IN_CASE';
export const APPLY_ALERT_STATUS_BULK_IN_CASE_SUCCESS =
  'APPLY_ALERT_STATUS_BULK_IN_CASE_SUCCESS';
export const APPLY_ALERT_STATUS_BULK_IN_CASE_FAIL =
  'APPLY_ALERT_STATUS_BULK_IN_CASE_FAIL';
export const APPLY_ALERT_STATUS_BULK_IN_CASE_RESET =
  'APPLY_ALERT_STATUS_BULK_IN_CASE_RESET';

export const applyAlertStatusBulkInCase = ({
  caseId,
  alertIds,
  targetStatus,
  reason,
  triggeringAlertId
}) => ({
  type: APPLY_ALERT_STATUS_BULK_IN_CASE,
  payload: { caseId, alertIds, targetStatus, reason, triggeringAlertId }
});

export const applyAlertStatusBulkInCaseSuccess = (data) => ({
  type: APPLY_ALERT_STATUS_BULK_IN_CASE_SUCCESS,
  payload: data
});

export const applyAlertStatusBulkInCaseFail = (message) => ({
  type: APPLY_ALERT_STATUS_BULK_IN_CASE_FAIL,
  payload: { message }
});

export const applyAlertStatusBulkInCaseReset = () => ({
  type: APPLY_ALERT_STATUS_BULK_IN_CASE_RESET
});
